import Vue from 'vue'

const isArray = v => Object.prototype.toString.call(v) === '[object Array]';
const isObject = v => Object.prototype.toString.call(v) === '[object Object]';
const isString = v => typeof v === 'string';
const isNumber = v => typeof v === 'number' && !isNaN(v);
Vue.prototype.$SELFTYPEJUDGE = {
    isArray,
    isString,
    isObject,
    isNumber
};
